import { ErrorContent } from './widgets';

interface ErrorPageProps {
  error: Error;
}

export const ErrorPage = (props: ErrorPageProps) => {
  return <ErrorContent error={props.error} />;
};
